import { LinkIcon } from "lucide-react";

import { LinkChooser } from "simplydo/react/components/Choosers/LinkChooser";
import type { EditorMenuItem } from "simplydo/react/richtext/BasicRichText";
import { useEditorContext } from "simplydo/react/richtext/editor/EditorContext";

import type { ChooserState, SetChooser } from "../menuTypes";

export const getSimpleMenu = (
  chooser: ChooserState,
  setChooser: SetChooser,
): Array<EditorMenuItem> => [
  {
    name: "link",
    icon: LinkIcon,
    onClick: ({ commands, isActive, selectedText }) => {
      if (isActive) {
        commands.removeLink?.();
      } else {
        setChooser("link", !chooser.link?.open, selectedText);
      }
    },
    MenuItem: ({ RenderItem, itemProps }) => {
      const { commands } = useEditorContext();
      return (
        <LinkChooser
          trigger={
            <div>
              <RenderItem {...itemProps} />
            </div>
          }
          isOpen={!!chooser.link?.open}
          shouldFix={false}
          onClose={() => setChooser("link", false)}
          hideLinkText
          onComplete={(_text, url) => {
            commands.insertLink?.({ href: url });
            setChooser("link", false);
          }}
        />
      );
    },
  },
];
